import React from 'react';

const PrescriptionWarningIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="30" viewBox="0 0 24 30" fill="none">
      <path
        d="M0.246399 4.62644C0.246399 8.39611 -0.551978 18.1634 0.725505 20.8194C2.00301 23.561 9.02862 27.9305 11.9826 29.9868C14.9366 27.9306 21.9623 23.6467 23.2397 20.8194C24.5172 18.1633 23.7985 8.39622 23.7985 4.62644C20.7647 3.2555 14.8567 0 11.9826 0C9.18825 0 3.28023 3.25577 0.246399 4.62644Z"
        fill={'#2291B8'}
      />
      <path
        d="M11.1041 16.8799L10.8641 9.3759H12.7681L12.5441 16.8799H11.1041ZM11.7921 20.5919C11.1361 20.5919 10.5761 20.0959 10.5761 19.4079C10.5761 18.7359 11.1361 18.2239 11.7921 18.2239C12.4641 18.2239 13.0401 18.7359 13.0401 19.4079C13.0401 20.0959 12.4641 20.5919 11.7921 20.5919Z"
        fill={'white'}
      />
    </svg>
  );
};

export default PrescriptionWarningIcon;
